// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

const filesToUpload = [];
const fileUploadInput = document.querySelectorAll('.upload-box__input');

if (fileUploadInput.length > 0) {
  let nextFileID = 1;

  /* ---------------- TOAST ---------------- */

  const showToast = (message, type = 'default') => {
    const toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) return;

    const toast = document.createElement('div');
    toast.className = `toast-container-item toast-container-item--${type}`;
    toast.textContent = message;

    toastContainer.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('toast-hide');

      const onAnimationEnd = (e) => {
        if (e.target !== toast || e.animationName !== 'toast-out') return;
        toast.removeEventListener('animationend', onAnimationEnd);
        setTimeout(() => toast.remove(), 200);
      };

      toast.addEventListener('animationend', onAnimationEnd);
    }, 3000);
  };

  const fileRemoved = new Event('fileRemoved');

  const fileUploader = async (evt, files) => {
    const input = evt.target;
    const parentElem = evt.target.closest('.file-upload');
    const textEle = parentElem.querySelector('.uploaded-files .section-header');
    const selectedList = parentElem.querySelector('.uploaded-files__list');
    const { uploadKey } = parentElem.dataset;
    // const selectedFileExists = filesToUpload.find((file) => file?.selected && uploadKey === file?.parentId);

    const successMessage =
      parentElem.querySelector('[data-success-upload-message]')?.getAttribute('data-success-upload-message') ||
      'Datoteka je bila uspešno naložena.';

    const minFileSizeMessage =
      parentElem
        .querySelector('[data-fv-file___min-total-size___message]')
        ?.getAttribute('data-fv-file___min-total-size___message') || 'velikost datotek mora biti vsaj.';

    const parseSize = (value) => {
      if (!value) return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const minFileSize = parseSize(
      parentElem.querySelector('[data-fv-file___min-total-size]')?.getAttribute('data-fv-file___min-total-size'),
    );

    const perFileMinSize = parseSize(
      parentElem.querySelector('[data-fv-file___min-size]')?.getAttribute('data-fv-file___min-size'),
    );
    const perFileMaxSize = parseSize(
      parentElem.querySelector('[data-fv-file___max-size]')?.getAttribute('data-fv-file___max-size'),
    );

    const singleMinFileSizeMessage =
      parentElem
        .querySelector('[data-fv-file___min-size___message]')
        ?.getAttribute('data-fv-file___min-size___message') || 'Datoteka je premajhna.';

    const singleMaxFileSizeMessage =
      parentElem
        .querySelector('[data-fv-file___max-size___message]')
        ?.getAttribute('data-fv-file___max-size___message') || 'velikost datotek mora biti vsaj.';

    /* --- single-file mode cleanup --- */
    if (!input.multiple) {
      for (let i = filesToUpload.length - 1; i >= 0; i--) {
        if (filesToUpload[i].parentId === uploadKey) {
          filesToUpload.splice(i, 1);
        }
      }
    }

    // count files BEFORE rendering
    const beforeCount = filesToUpload.filter((f) => f.parentId === uploadKey).length;
    const stagedFileIds = [];
    const hasSelectedFile = filesToUpload.some((file) => file.selected && file.parentId === uploadKey);

    /* --- stage new files (transaction) --- */
    Array.from(files).forEach((file, index) => {
      if (perFileMinSize && file.size < perFileMinSize) {
        showToast(`"${file.name}" ${singleMinFileSizeMessage}`, 'error');
        return;
      }

      if (perFileMaxSize && file.size > perFileMaxSize) {
        showToast(`"${file.name}" ${singleMaxFileSizeMessage}`, 'error');
        return;
      }

      const shouldBeSelected = uploadKey !== 'files-step-4' && !hasSelectedFile && index === 0;

      filesToUpload.push({
        id: nextFileID,
        parentId: uploadKey,
        file,
        ...(uploadKey !== 'files-step-4' && { selected: shouldBeSelected }),
      });
      stagedFileIds.push(nextFileID);
      nextFileID += 1;
    });

    const revertStagedFiles = () => {
      for (let i = filesToUpload.length - 1; i >= 0; i--) {
        const item = filesToUpload[i];
        if (item.parentId === uploadKey && stagedFileIds.includes(item.id)) {
          filesToUpload.splice(i, 1);
        }
      }
    };

    // wait for validation to finish
    // eslint-disable-next-line no-promise-executor-return
    const waitForValidation = () => new Promise((resolve) => setTimeout(resolve, 0));
    await waitForValidation();

    // Remove invalid files
    if (input.multiple) {
      for (let i = filesToUpload.length - 1; i >= 0; i--) {
        const item = filesToUpload[i];

        // eslint-disable-next-line no-continue
        if (item.parentId !== uploadKey) continue;

        if (item.file.size < minFileSize) {
          showToast(`"${item.file.name}" ${minFileSizeMessage}`, 'error');
          filesToUpload.splice(i, 1);
        }
      }
    }

    if (parentElem.querySelector('.is-validation-failed')) {
      revertStagedFiles();
      input.value = '';
      return;
    }

    /* --- render cards --- */

    // Uploaded Valid Files List
    // const currentFiles = filesToUpload.filter((item) => item.parentId === uploadKey);

    // console.table(
    //   currentFiles.map((file) => ({
    //     id: file.id,
    //     name: file.file.name,
    //     sizeKB: Math.round(file.file.size / 1024),
    //     type: file.file.type,
    //     parentId: file.parentId,
    //     selected: file.selected,
    //   })),
    // );

    const response = await fetch(`/wp-admin/admin-ajax.php?action=getUploadCardHtml&step=${uploadKey}`);
    const data = await response?.json();

    const fileCardList = filesToUpload
      .filter((item) => item.parentId === uploadKey)
      .map((file) => {
        const statusTag = file?.selected ? 'mod-tag--default' : 'mod-tag--yellow';
        const isPdf = file.file.type === 'application/pdf' || file.file.name.toLowerCase().endsWith('.pdf');
        const isArchive = /\.(zip|rar|7z|tar|gz)$/i.test(file.file.name);

        let html = data?.data?.html
          .replace('{{file_id}}', file.id)
          .replace('{{file_name}}', file.file.name)
          .replace('{{input_value}}', file.value ?? '')
          .replace(statusTag, `${statusTag} : hide`);

        if (isPdf) {
          html = html.replace(/<img[^>]*>/i, '<i class="icon icon-pdf"></i>');
        } else if (isArchive) {
          html = html.replace(/<img[^>]*>/i, '<i class="icon icon-zip"></i>');
        } else {
          if (!file.previewUrl) {
            file.previewUrl = URL.createObjectURL(file.file);
          }
          html = html.replace('{{image_url}}', file.previewUrl);
        }

        return html;
      })
      .join('');

    // count files AFTER processing
    const afterCount = filesToUpload.filter((f) => f.parentId === uploadKey).length;

    if (fileCardList) {
      selectedList.innerHTML = fileCardList;

      // Show success toast ONLY when valid file was added
      if (afterCount > beforeCount) {
        showToast(successMessage);
      }
    }

    textEle?.classList.toggle('is-active', afterCount > 0);
  };

  fileUploadInput.forEach((el) => {
    el.addEventListener('change', (evt) => {
      fileUploader(evt, evt.target.files);
    });

    // File drop
    const parentElem = el.closest('.upload-box');
    const holder = parentElem.querySelector('.upload-box__inner');
    if (holder) {
      holder.ondragover = () => {
        parentElem.classList.add('is-hovered');
      };
      holder.ondragend = () => {
        parentElem.classList.remove('is-hovered');
      };
      holder.ondrop = (e) => {
        e.preventDefault();
        parentElem.classList.remove('is-hovered');
        el.files = e.dataTransfer.files;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };
    }
  });

  // *******************************************************************************
  // Remove uploaded files
  // *******************************************************************************
  attachEvent('.uploaded-files .delete-button', 'click', (el) => {
    const removeParentElem = el.target.closest('.uploaded-files__item');
    if (!removeParentElem) return;

    const container = removeParentElem.closest('.file-upload');
    const targetInput = container.querySelector('.upload-box input');
    const parentList = removeParentElem.closest('.uploaded-files__list');
    const targetKey = removeParentElem.dataset.key;

    const fileIndex = filesToUpload.findIndex((file) => `file-${file?.id}` === targetKey);
    if (fileIndex < 0) return;

    const tmpFile = filesToUpload[fileIndex];
    filesToUpload.splice(fileIndex, 1);

    targetInput.value = '';
    targetInput.dispatchEvent(fileRemoved);
    removeParentElem.remove();

    const remainingFilesCount = filesToUpload.filter((file) => file.parentId === container.dataset.uploadKey).length;
    container.querySelector('.uploaded-files .section-header')?.classList.toggle('is-active', remainingFilesCount > 0);

    if (!('selected' in tmpFile)) return;

    const selectedExists = filesToUpload.some((file) => file.selected && file.parentId === container.dataset.uploadKey);
    if (!selectedExists) {
      const newFileIndex = filesToUpload.findIndex(
        (file) => file.parentId === container.dataset.uploadKey && 'selected' in file,
      );
      if (newFileIndex < 0) return;

      const newFile = filesToUpload[newFileIndex];
      newFile.selected = true;

      const newSelectedElem = parentList.querySelector(`[data-key="file-${newFile.id}"]`);
      if (!newSelectedElem) return;

      newSelectedElem.querySelectorAll('.mod-tag').forEach((tag) => tag.classList.toggle('hide'));
    }
  });

  attachEvent('.uploaded-files__item-image', 'click', (el) => {
    const targetElement = el.target.closest('.uploaded-files__item');
    const parentList = targetElement.closest('.uploaded-files__list');
    const container = parentList.closest('.file-upload');

    const oldIndex = filesToUpload.findIndex((file) => file.selected && file.parentId === container.dataset.uploadKey);
    const oldElement = parentList.querySelector(`[data-key="file-${String(filesToUpload[oldIndex]?.id)}"]`);
    const oldTags = oldElement?.querySelectorAll('.mod-tag');

    const targetIndex = filesToUpload.findIndex(
      (file) => `file-${file?.id}` === targetElement.dataset.key && file?.parentId === container.dataset.uploadKey,
    );
    const targetTags = targetElement.querySelectorAll('.mod-tag');

    filesToUpload[oldIndex].selected = false;
    filesToUpload[targetIndex].selected = true;

    [...oldTags, ...targetTags].forEach((tag) => {
      tag?.classList?.toggle('hide');
    });
  });

  attachEvent('.textarea-with-counter', 'input', (el) => {
    const parent = el.target.closest('.uploaded-files__item');
    const container = parent.closest('.file-upload');
    const textareaInput = parent?.querySelector('textarea');

    const fileIndex = filesToUpload.findIndex(
      (file) => file.parentId === container.dataset.uploadKey && `file-${file.id}` === parent.dataset.key,
    );
    filesToUpload[fileIndex].value = textareaInput?.value;
  });

  // *******************************************************************************
  // Update Size
  // *******************************************************************************

  document.addEventListener('DOMContentLoaded', () => {
    const sizeAttributes = [
      'data-fv-file___min-size',
      'data-fv-file___max-size',
      'data-fv-file___min-total-size',
      'data-fv-file___max-total-size',
    ];

    fileUploadInput.forEach((input) => {
      sizeAttributes.forEach((attr) => {
        const value = input.getAttribute(attr);

        if (!value) return;

        const sizeInBytes = parseFloat(String(value).replace(',', '.')) * 1024 * 1024;

        if (Number.isFinite(sizeInBytes)) {
          input.setAttribute(attr, Math.round(sizeInBytes));
        }
      });
    });
  });
}
